import { render, staticRenderFns } from "./Quotations.vue?vue&type=template&id=7a31d64e&scoped=true&"
import script from "./Quotations.vue?vue&type=script&lang=js&"
export * from "./Quotations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a31d64e",
  null
  
)

export default component.exports